import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import _merge from "lodash/merge";
import _compact from "lodash/compact";
import _flattenDeep from "lodash/flattenDeep";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

/**
 * Merges { className, style } objects together into a single object.
 */
var mergeStyles = function mergeStyles() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var _args$reduce = args.reduce(function (memo, _ref) {
    var className = _ref.className,
        style = _ref.style;
    memo.classNameProps.push(className);
    memo.styleProps.push(style);
    return memo;
  }, {
    classNameProps: [],
    styleProps: []
  }),
      classNameProps = _args$reduce.classNameProps,
      styleProps = _args$reduce.styleProps;

  classNameProps = _flattenDeep(_compact(classNameProps));
  styleProps = _flattenDeep(_compact(styleProps));
  return {
    className: classNameProps.length ? classNameProps.join(' ') : undefined,
    style: styleProps.length ? _merge.apply(void 0, [{}].concat(_toConsumableArray(styleProps))) : undefined
  };
};

export default mergeStyles;